
import OnboardingResearch from './onboarding-research.vue'
import Reasoning from './reasoning.vue'

export default {
  components: {Reasoning, OnboardingResearch},
  props: {
    chatId: {type: String, required: true},
    mode: {type: String, required: true},
    reasoning: {type: [Object, Array, String], required: false, default: undefined},
    completed: {type: Boolean, default: false},
  },
  emits: ['end']
}
